import { Col, Form, Row } from 'antd'
import { get } from 'lodash'
import { defaultFormItemLayout, rules } from '../../../../modules/FormItems'
import React, { Fragment } from 'react'

function BankSelectDetails(props) {
  const { ContractSelect, contract } = props
  const { getFieldDecorator } = props.form

  return (
    <Fragment>
      <Form layout="horizontal">
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Select Bank" extra="If it's Empty There are no other Bank.">
              {getFieldDecorator('bank._id', {
                initialValue: get(contract, 'bank._id'),
                rules: rules.select,
              })(<ContractSelect valueAtr="title" placeholder={'No'} />)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Fragment>
  )
}

export default Form.create()(BankSelectDetails)
